// 53.7����
// export const LICENSE_KEY = 'iPyibkhDuoJTnUSQHHfw8Ratzye+cAVTzxYOOZumnC8L82GKXBL6c2Q=';
// 53.7�ȍ~
export const LICENSE_KEY =
  'dUxNUGJxV2Iwa095QmZ1ZVdKR3cvMWExY0VEMXBiektRL2hyL1JkY1g2QXZaQ1licUIyS2FRQ1RLNjQ9LU1qQXlOakEyTVRrPQ==';

  /*
export const LICENSE_KEY =
  'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MDY0NTExOTksImp0aSI6IjcxYjU0MjQwLTMzMjctNGZhNC05NDRmLTc2MGJhNWQ5Nzk3ZCIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwiZmVhdHVyZXMiOlsiRFJVUCJdLCJ2YyI6IjVlMDlkNmNlIn0.iMANc9UlfASUcSG6F2sKh7e1W17Y0WebXDa0iWl5qd8L7a6-bb13w0_xqbfvfHl0qYPBrGvdc6zZtbyeSUG92g';
*/

// CKEditor の原稿幅の選択肢
export const CKEDITOR_WIDTHS: Record<string, string> = {
  MANU_WIDTH_10_PERCENT: '10%',
  MANU_WIDTH_20_PERCENT: '20%',
  MANU_WIDTH_30_PERCENT: '30%',
  MANU_WIDTH_40_PERCENT: '40%',
  MANU_WIDTH_50_PERCENT: '50%',
  MANU_WIDTH_60_PERCENT: '60%',
  MANU_WIDTH_70_PERCENT: '70%',
  MANU_WIDTH_80_PERCENT: '80%',
  MANU_WIDTH_90_PERCENT: '90%',
};
